export default {
  get() {
    return window.app.storage.getItem('theme') || 'dark';
  },
  set(theme) {
    return window.app.storage.setItem('theme', theme);
  }
};